import { Box, Divider, Skeleton } from "@mui/material";
import React, { useMemo } from "react";

import { NotesContent } from "components/detector/NotesModal/NotesContent";
import { Typography } from "new-components/typography/Typography";
import { DetectorModes } from "types/createDetector";
import { Disagreement } from "types/disagreements";

import { DisagreementContent } from "./DisagreementContent";

export interface DisagreementWithNotesProps {
  isLargeMode: boolean;
  currentDisagreement: Disagreement;
  onFinishRelabel: () => void;
}

export function DisagreementWithNotes(props: DisagreementWithNotesProps) {
  const { isLargeMode, currentDisagreement, onFinishRelabel } = props;

  const detectorData: any = useMemo(
    () => ({
      id: currentDisagreement.predictor?.id,
      name: currentDisagreement.predictor?.name,
      label_prompt: currentDisagreement.predictor?.label_prompt,
      mode: DetectorModes.BINARY,
    }),
    [currentDisagreement]
  );

  return (
    <Box>
      <Box className="flex justify-start items-center gap-2">
        <Typography variant="subtitle" className="text-black">
          Query:
        </Typography>
        <Typography variant="subtitle" fontWeight="semibold" className="text-primary-darker">
          {currentDisagreement?.predictor?.label_prompt}
        </Typography>
      </Box>
      <Divider className="border-b-2 my-4" />
      <Box className="flex justify-between gap-4">
        <Box className="w-[30%]">
          {!currentDisagreement ? (
            <Skeleton height="80vh" />
          ) : (
            <Box>
              {currentDisagreement && Object.keys(currentDisagreement).length > 0 ? (
                <DisagreementContent
                  isLargeMode={isLargeMode}
                  disagreementData={currentDisagreement}
                  onFinishRelabel={onFinishRelabel}
                />
              ) : (
                <Typography>Wrong URL</Typography>
              )}
            </Box>
          )}
        </Box>
        <Box className="flex flex-col gap-4 p-5 w-[70%] h-[72vh] sm:p-8 rounded-md p-6 overflow-y-auto">
          {currentDisagreement ? (
            <NotesContent
              ownerGroupId={currentDisagreement?.predictor?.owner?.id}
              ownerGroupName="User"
              detector={detectorData}
            />
          ) : (
            <Skeleton height="100%" />
          )}
        </Box>
      </Box>
    </Box>
  );
}
